import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PrimaryButton } from 'appSrc/components/UI';
import style from '../styles/style.module.css';

import demoImage from 'appSrc/assets/img/registration/step2/cards.png';
import demoImage2 from 'appSrc/assets/img/registration/step2/cards@2x.png';
import demoImage3 from 'appSrc/assets/img/registration/step2/cards@3x.png';

class StepZero extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className={ `${ style.stepZero } ${ style.listCreationStep }` }>
                <div className={ style.titleBar }>
                    <h2>First, take a look at this example list.</h2>
                    <p>Your content will show up in a similar format.</p>
                </div>
                <div className={ style.stepContent }>
                    <div className={ style.demoContainer }>
                        <img srcSet={ `${ demoImage} 478w, ${ demoImage2 } 956w, ${ demoImage3 } 1434w` } src={ demoImage } />
                    </div>
                    <div className={ style.buttonWrapper }>
                        <PrimaryButton
                        label='Got it'
                        fullWidth
                        onClick={ this.props.onSubmit } />
                    </div>
                </div>
            </div>
        );
    }
}
StepZero.defaultProps = {
    onSubmit: ()=>{},
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        ownLists: state.self.lists,
    };
};

export default connect( mapStateToProps )( StepZero );
